var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"promotionsList pl-0 ml-0"},_vm._l((_vm.promotions),function(promotion){return _c('promotionItem',{key:promotion.name,attrs:{"promotionData":promotion}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }